module.exports = __webpack_public_path__ + "img/IOTA.40bd9599.svg";